import React from 'react';

export function NumberSpan({numberFmt, value}) {
  return <span>{value && numberFmt.format(value)}</span>
}